// extracted by mini-css-extract-plugin
module.exports = {"section__subtitle--content":"SectionSubtitle_section__subtitle--content__3HXnj"};